import { Action } from 'redux';

export interface MailchimpConnectionParams {
    tempCode?: string;
    dc?: string;
    accessToken?: string;
    hasError?: boolean;
}

export interface MailchimpPaginationParams {
    offset: number;
    count: number;
}

export interface MailchimpList {
    id: string;
    name: string;
    double_optin: boolean;
    date_created: string;
    stats: {
        member_count: number;
        total_contacts: number;
    };
}

export interface MailchimpLists {
    data: MailchimpList[];
    paginationParams: MailchimpPaginationParams;
    total: number;
}

export interface MailchimpListMember {
    id: string;
    email_address: string;
    unique_email_id: string;
    contact_id: string;
    full_name: string;
}
export interface IntegrationsState {
    mailchimp: {
        connection: MailchimpConnectionParams;
        lists: MailchimpLists & {
            isLoading: boolean;
            isLoaded: boolean;
        };
        listMembers: {
            progressPercent: number;
            isLoading: boolean;
            isLoaded: boolean;
        };
    };
}

export interface GetMailchimpConnectionParamsAction extends Action {
    type: IntegrationsActionTypes.GET_MAILCHIMP_CONNECTION_PARAMS;
    payload: {
        tempCode: string;
    };
}

export interface SetMailchimpConnectionParamsAction extends Action {
    type: IntegrationsActionTypes.SET_MAILCHIMP_CONNECTION_PARAMS;
    payload: MailchimpConnectionParams;
}

export interface GetMailchimpListsAction extends Action {
    type: IntegrationsActionTypes.GET_MAILCHIMP_LISTS;
    payload: MailchimpPaginationParams;
}

export interface SetMailchimpListsAction extends Action {
    type: IntegrationsActionTypes.SET_MAILCHIMP_LISTS;
    payload: MailchimpLists;
}

export interface GetMailchimpListMembersActionPayload {
    listId: string;
}

export interface GetMailchimpListMembersAction extends Action {
    type: IntegrationsActionTypes.GET_MAILCHIMP_LIST_MEMBERS;
    payload: GetMailchimpListMembersActionPayload;
}

export interface SetMailchimpListMembersProgressAction extends Action {
    type: IntegrationsActionTypes.SET_MAILCHIMP_LIST_MEMBERS_PROGRESS;
    payload: number;
}

export enum IntegrationsActionTypes {
    GET_MAILCHIMP_CONNECTION_PARAMS = '@@integrations/GET_MAILCHIMP_CONNECTION_PARAMS',
    SET_MAILCHIMP_CONNECTION_PARAMS = '@@integrations/SET_MAILCHIMP_CONNECTION_PARAMS',
    GET_MAILCHIMP_LISTS = '@@integrations/GET_MAILCHIMP_LISTS',
    SET_MAILCHIMP_LISTS = '@@integrations/SET_MAILCHIMP_LISTS',
    GET_MAILCHIMP_LIST_MEMBERS = '@@integrations/GET_MAILCHIMP_LIST_MEMBERS',
    SET_MAILCHIMP_LIST_MEMBERS_PROGRESS = '@@integrations/SET_MAILCHIMP_LIST_MEMBERS_PROGRESS',
}
